<div class="text-center mt-5">
    <!-- <img src="../../assets/img/motoria/logo-motoria-p.png" /> -->
    <img src="../../assets/img/brainscorm/bs.png" />
</div>